import { defineMessages } from 'react-intl';

const scope = 'app.components.ListResultsStates';

const messages = defineMessages({
  default: {
    defaultMessage: 'Default message',
    id: `${scope}.empty`,
  },
  empty: {
    defaultMessage: 'No {resource}',
    id: `${scope}.empty`,
  },
  emptySearch: {
    defaultMessage: 'No match found for {searchString}',
    id: `${scope}.emptySearch`,
  },
  error: {
    defaultMessage: 'Search request failed. Please try again.',
    id: `${scope}.error`,
  },
  loading: {
    defaultMessage: 'Loading {resource}...',
    id: `${scope}.loading`,
  },
});

export default messages;
